import store from "../store";
import { resetPassword } from "./restFunctions";
import signInSubmit from "./signInSubmit";

export default async (values, source) => {
  const { username, newPassword: password } = values;
  const {
    queries: { resetPasswordCode }
  } = store;
  if (resetPasswordCode) {
    store.setUI("formSubmitting", true);
    await resetPassword(username, password, resetPasswordCode, source)
      .then(async response => {
        // store.setUI("formSubmitting", false);
        const { isOK } = response;
        if (isOK) {
          // store.notifyToast("success", "Your password has been changed", {
          //   draggable: true
          // });
          store.forms.newPasswordForm.clear();
          store.setQuery("code", null);
          return await signInSubmit({ username, password }, "newPasswordForm");
        }
        return store.setUI("formSubmitting", false);
      })
      .catch(error => {
        store.setUI("formSubmitting", false);
      });
  }
};
